export function isMobileDevice() {
  const isMobileDevice =  /Mobi/.test(navigator.userAgent);
  return isMobileDevice;
}
   